const FormSelect = ({
  register,
  required,
  validate = {},
  error,
  name,
  placeholder,
  formLabel,
  options,
  disabled = false,
  readOnly = false,
  defaultValue,
}) => (
  <div className="input-group mb-3">
    <div
      className="input-group-prepend"
      style={disabled || readOnly ? { backgroundColor: "#1D253B" } : {}}
    >
      <span className="input-group-text px-3">{formLabel}</span>
    </div>
    <select
      className={`form-control ${readOnly && "text-light"}`}
      style={!readOnly && !disabled ? { backgroundColor: "#27293D" } : {}}
      {...register(name, {
        required,
        ...validate,
      })}
      {...(defaultValue && { defaultValue })}
      placeholder={placeholder}
      disabled={disabled || readOnly}
    >
      {options.map((option, index) => (
        <option
          key={index}
          className="bg-dark"
          value={option.value}
          disabled={option.disabled}
        >
          {option.label}
        </option>
      ))}
    </select>
    {error && <div className="text-danger mb-3">{error?.message}</div>}
  </div>
);

export default FormSelect;
